/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { inject, Injectable } from '@angular/core';
import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TranslateService } from '@ngx-translate/core';
import { CellDetailsDialogComponent } from './cell-details-dialog.component';

@Injectable({ providedIn: 'root' })
export class CellDetailsDialogService {
  dialogService = inject(DialogService);
  translateService = inject(TranslateService);

  defaultConfig: DynamicDialogConfig = {
    width: '40vw',
    style: { 'min-height': '150px', 'max-height': '450px' },
    modal: true,
    closeOnEscape: true,
    dismissableMask: true,
    closable: true,
    focusOnShow: false,
    breakpoints: {
      '1024px': '60vw',
      '640px': '80vw',
    },
  };

  openDialog(content: { field: string; content: string }, parentKey: string) {
    this.dialogService.open(CellDetailsDialogComponent, {
      ...this.defaultConfig,
      header: this.translateService.instant(`delivery-app.${parentKey}.${content.field}`),
      data: { details: content.content },
    });
  }
}
